module.exports = __webpack_public_path__ + "static/media/constellix-logo.ca8d8fff.svg";